
import React from 'react';

interface ThemeProviderProps {
  theme: 'light' | 'dark' | 'sepia';
  children: React.ReactNode;
}

export const getThemeClasses = (theme: 'light' | 'dark' | 'sepia') => {
  switch (theme) {
    case 'dark':
      return 'bg-slate-900 text-gray-100 theme-dark';
    case 'sepia':
      return 'bg-amber-50 text-amber-900 theme-sepia';
    case 'light':
    default:
      return 'bg-white text-gray-900 theme-light';
  }
};

const ThemeProvider: React.FC<ThemeProviderProps> = ({ theme, children }) => {
  console.log('[THEME_PROVIDER] Rendering with theme:', theme, '- NO SCROLL applied here');
  
  return (
    <div className={`pulse-content-wrapper transition-colors duration-300 ${getThemeClasses(theme)}`}>
      {children}
    </div>
  );
};

export default ThemeProvider;
